import React from "react"
import { motion, AnimatePresence } from "framer-motion"

import LoadingIcon from "../global/loading"

function MobileProductForm({
  quantity,
  setQuantity,
  handleAddToCart,
  available,
  loading,
}) {
  return (
    <div className="product__mobile-product-form">
      <div className="product__selector--mobile">
        <h4 className="p">SELECT QUANTITY</h4>
        <div>
          <button
            title={"Decrease Quantity"}
            onClick={() => setQuantity(quantity - 1)}
          >
            <span>-</span>
          </button>
          <input
            type="number"
            name="Quantity"
            value={quantity}
            onChange={e => setQuantity(Number(e.target.value))}
          />
          <button
            title={"Decrease Quantity"}
            onClick={() => setQuantity(quantity + 1)}
          >
            <span>+</span>
          </button>
        </div>
      </div>
      <button
        className="product__atc--mobile"
        disabled={loading || !available}
        title="Add to Cart"
        onClick={handleAddToCart}
      >
        <AnimatePresence exitBeforeEnter>
          {loading ? (
            <motion.div
              key={"loading"}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <LoadingIcon />
            </motion.div>
          ) : (
            <motion.div
              key="add"
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <span>{available ? "Select Quantity" : "Sold Out"}</span>
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>
  )
}

export default MobileProductForm
